import {
  ABOUT_CTA,
  ABOUT_INTRO,
  BRAND_NOTE,
  POSITIONING,
  STORY,
  TIMELINE,
  VALUES,
} from '@/content/about';
import { ActionRow } from '@/components/ActionButton';
import { Callout, Card } from '@/components/Card';
import { Icon } from '@/components/Icon';
import { Reveal } from '@/components/Reveal';
import { PageHero, Section, SectionHeading } from '@/components/Section';
import { Seo } from '@/components/Seo';

export function AboutPage() {
  return (
    <>
      <Seo
        path="/about"
        crumbs={[
          { name: '首页', path: '/' },
          { name: '关于我们', path: '/about' },
        ]}
      />

      <PageHero
        eyebrow={ABOUT_INTRO.eyebrow}
        title={ABOUT_INTRO.title}
        lead={ABOUT_INTRO.lead}
        actions={<ActionRow actions={ABOUT_INTRO.actions} />}
      />

      <Section>
        <SectionHeading
          eyebrow="定位"
          title="个人开发者可用，企业同样可用"
          lead="两者共用同一套内核，差别仅在于部署位置、角色划分与定制深度。"
        />

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {POSITIONING.map((item, index) => (
            <Reveal key={item.title} delay={index} as="div">
              <Card interactive className="flex h-full flex-col gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-grad-tint text-brand">
                  <Icon name={item.icon} size={20} />
                </span>
                <h3 className="text-base font-semibold text-fg">{item.title}</h3>
                <p className="text-sm leading-relaxed text-fg-muted">{item.text}</p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section tone="raised">
        <div className="grid grid-cols-[minmax(0,1fr)] gap-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:items-start">
          <div>
            <SectionHeading eyebrow="来龙去脉" title="为何先做机体，再做平台" />
            <div className="mt-6 space-y-4 text-[0.9375rem] leading-relaxed text-fg-muted">
              {STORY.map((paragraph) => (
                <p key={paragraph.text}>{paragraph.text}</p>
              ))}
            </div>
          </div>

          <ol className="relative flex flex-col gap-6 border-l border-line pl-6">
            {TIMELINE.map((item) => (
              <li key={item.phase} className="relative">
                <span
                  className="absolute -left-[1.9rem] top-1.5 h-2 w-2 rounded-full bg-palette-4"
                  aria-hidden="true"
                />
                <span className="label-mono">{item.phase}</span>
                <h3 className="mt-1.5 text-sm font-semibold text-fg">{item.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-fg-muted">{item.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </Section>

      <Section>
        <SectionHeading
          eyebrow="原则"
          title="四条落实于实现的原则"
          lead="每一条都能在平台的具体行为中找到对应，而非停留于口号。"
        />

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {VALUES.map((value) => (
            <Card key={value.title} className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <Icon name={value.icon} size={18} className="text-fg-muted" />
                <h3 className="text-base font-semibold text-fg">{value.title}</h3>
              </div>
              <p className="text-sm leading-relaxed text-fg-muted">{value.text}</p>
              <p className="mt-auto border-t border-line pt-3 text-xs leading-relaxed text-fg-subtle">
                {value.evidence}
              </p>
            </Card>
          ))}
        </div>
      </Section>

      <Section tone="soft">
        <div className="max-w-3xl">
          <Callout label={BRAND_NOTE.title} icon="info">
            <div className="space-y-3">
              {BRAND_NOTE.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </Callout>
        </div>
      </Section>

      <Section tone="raised">
        <div className="flex flex-col items-start gap-5">
          <span className="label-mono text-brand">{ABOUT_CTA.eyebrow}</span>
          <h2 className="max-w-2xl text-2xl font-semibold text-fg md:text-3xl">{ABOUT_CTA.title}</h2>
          <p className="max-w-2xl text-[0.9375rem] leading-relaxed text-fg-muted">{ABOUT_CTA.text}</p>
          <ActionRow actions={ABOUT_CTA.actions} />
        </div>
      </Section>
    </>
  );
}
